import { FormattedMessage } from "react-intl";
import { useFieldArray, useFormContext } from "react-hook-form";

import { useGetCountries } from "api/queries/common/useGetCountries";
import FlightComponent from "../../Delivery/FlightComponent";

const customFlightInfo = {
  airline_code: "",
  flight_number: null,
  departure_date: null,
  departure_time: null,
  departure_airport_code: "",
  arrival_date: null,
  arrival_time: null,
  arrival_airport_code: "",
};

export default function FlightForm() {
  const methods = useFormContext();
  const { fields, append, remove } = useFieldArray({
    name: "schedule.flights",
    control: methods.control,
    shouldUnregister: true,
  });

  const { data: countries = [] } = useGetCountries({
    refetchOnMount: false,
  });

  return (
    <>
      {fields.map((airplane, index) => (
        <div key={airplane.id} className="mb-3xl">
          <FlightComponent index={index} countries={countries} remove={remove} />
        </div>
      ))}
      <p onClick={() => append(customFlightInfo)} className="text-blue-200 font-b4 cursor-pointer">
        <FormattedMessage id="quote.provider.schedule.addFlight" defaultMessage="Add flight" />
      </p>
    </>
  );
}
